import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class WipControlService {
    private headers: HttpHeaders;
    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }

    AddWipControl(wipData) {
        return this.http.post<any>('WIPControl/AddWipControl', wipData, { headers: this.headers });
    }

    GetWIPControlPeriod() {
        return this.http.get<any>('WIPControl/GetWIPControlPeriodList', { headers: this.headers });
    }

    UpdateWIPControlPeriod(wipData) {
        return this.http.post<any>('WIPControl/UpdateWIPControlPeriod', wipData, { headers: this.headers });
    }

    GetWIPControlErrorList(startDuration, endDuration) {
        return this.http.get<any>('WIPControl/GetWIPControlErrorList?startDuration=' + startDuration + '&endDuration=' + endDuration, { headers: this.headers });
    }

    GetWIPControlPeriodbyId(wIPcontrolId) {
        return this.http.get<any>('WIPControl/GetWIPControlPeriod?wIPcontrolId=' + wIPcontrolId, { headers: this.headers });
    }
    UpdateWIPEndDuration(wipData) {
        return this.http.post<any>('WIPControl/UpdateWIPEndDuration', wipData, { headers: this.headers });
    }

    GetWIPControlWarningList(startDuration, endDuration) {
        return this.http.get<any>('WIPControl/GetWIPControlWarningList?startDuration=' + startDuration + '&endDuration=' + endDuration, { headers: this.headers });
    }

    UpdateWIPClosePeriod(wipInput) {
        return this.http.post<any>('WIPControl/UpdateWIPClosePeriod', wipInput, { headers: this.headers });
    }

    AddWipControlNotifications(wIPcontrolId, userNotification, type, startDuration, endDuration) {
        //Dev: Rahul Newara CUST - 3980 Date: 03 - 05 - 2024
        let userNotifications = {
            wIPcontrolId: wIPcontrolId,
            userNotification: userNotification,
            type: type,
            startDuration: startDuration,
            endDuration: endDuration
        };
        return this.http.post<any>('WIPControl/AddWipControlNotifications', userNotifications, { headers: this.headers });
    }

    GetInvoiceDetailbyId(invoiceId) {
        return this.http.get<any>('WIPControl/GetInvoiceDetailbyId?invoiceId=' + invoiceId, { headers: this.headers })
    }

    syncWipControlXeroBlue(wipControlId: number) {
        return this.http.post<any>('Integration/ManualJournel?wipControlId=' + wipControlId, { headers: this.headers })
    }

    downloadAuditMovementReportbyDaterange(wipInput): Observable<HttpResponse<Blob>> {
        return this.http.post<any>('WIPControl/DownloadAuditMovementSummaryByDaterange', wipInput, { observe: 'response', responseType: 'blob' as 'json' });
    }

    downloadWipMovementReportbyDaterange(wipInput): Observable<HttpResponse<Blob>> {
        return this.http.post<any>('WIPControl/DownloadWIPMovementSummaryByDaterange', wipInput, { observe: 'response', responseType: 'blob' as 'json' });
    }
    
    downloadDebtorMovementSummaryReportbyDaterange(wipInput): Observable<HttpResponse<Blob>> {
        return this.http.post<any>('WIPControl/DownloadDebtorMovementSummaryByDaterange', wipInput, { observe: 'response', responseType: 'blob' as 'json' });
    }

    GetMinInvoiceDate() {
        return this.http.get<any>('WIPControl/GetMinInvoiceDate', { headers: this.headers });
    }
}